<template>
  <div>
    <div class="contentArea">
      <AgGrid />
    </div>
  </div>
</template>

<script>
import AgGrid from "./elements/ag-grid-table/AgGridTable";

import { mapGetters } from "vuex";

export default {
  components: {
    AgGrid,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      nowSlug: "getNowSlug",
      tabActive: "general/tabActive",
      page: "general/page",
    }),
  },

  async mounted() {
    await this.$store.dispatch("general/getPage", {
      url: "/admin/user",
    });
  },
  watch: {
    "$route.query.page"(to, from) {
      this.$store.dispatch("general/getPage", {
        url: "/admin/user",
      });
    },
  },
};
</script>
